<!-- 地区筛选 -->
<template>
  <el-form
    class="addressClass"
    ref="form"
    :model="form"
    label-width="80rem"
    size="small"
  >
    <div class="addressFilter">
      <el-form-item label="地区:" style="width: 220rem; margin-left: -35rem">
        <el-select v-model="form.address" disabled> </el-select>
      </el-form-item>
      <el-form-item label="题源:">
        <el-select v-model="form.source" disabled style="width: 260rem">
        </el-select>
      </el-form-item>
      <el-form-item label="年份:" style="width: 220rem" v-if="from !='special'">
        <el-select v-model="form.year" disabled> </el-select>
      </el-form-item>
      <el-form-item label="模块:" v-if="from === 'special'"> <!-- 四期 -->
        <el-input v-model="form.type" :disabled="isModuleDisabled" @blur="updateModule"></el-input>
      </el-form-item>
      <el-form-item label="模块:" v-if="from !== 'special' && editType=='add'" style="width: 320rem"> <!-- 三期 -->
        <el-input v-model="form.type" @blur="updateBookModule" :disabled="isAddModuleDisabled"></el-input>
      </el-form-item>
      <el-form-item label="模块:" style="width: 270rem" v-if="from !='special' && editType=='edit'">   
        <el-cascader
          v-model="form.type"
          :options="options"
          :props="{ expandTrigger: 'hover' }"
          :disabled="isDisabled"
          @change="handleChange"
        ></el-cascader>
      </el-form-item>

      <el-form-item label="启用:">
        <el-switch
          @change="deliveryChange"
          v-model="form.delivery"
          active-color="#0BAE6A"
        ></el-switch>
      </el-form-item>
    </div>

    <el-form-item>
      <el-button class="btnAddress preview" @click="preview" size="small">
        <img src="../../assets/images/icon-preview.png" alt="" />
        预览
      </el-button>
      <el-button
        type="primary"
        @click="onSubmit"
        class="btnAddress"
        size="small"
        
      >
      <!-- :disabled="saveDisabled" -->
        <img src="../../assets/images/icon-preserve.png" alt="" />
        保存
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
const TAG = "[AddressFilter.vue] ";
import { changeModuleStatus, getModuleStatus, checkModuleName,getModuleList } from "@/api/addModule";
import { EventBus } from "@/utils/event-bus";
import { isAddressType } from "@/constants/constants";
import { mapMutations } from "vuex";

export default {
  name: "AddressFilter",
  data() {
    return {
      options: [],
      // [
      //   {
      //     value: "听说-模拟训练",
      //     label: "听说-模拟训练",
      //   },
      //   {
      //     value: "题型-专项训练",
      //     label: "题型-专项训练",
      //   },
      // ],
      form: {
        address: "",
        source: "",
        year: "",
        type: "听说模拟训练",
        delivery: true,
        resource: "",
        desc: "",
        module: "",
      },
      isDisabled: false, // 类型是否禁用
      isModuleDisabled: false, // 类型是否禁用
      hasType: false, //新增还是编辑模块
      // saveDisabled: true,
      editType: '',  //判断是编辑状态还是新增状态
      moduleArr:[],
      isAddModuleDisabled: false,
      catalog_Id: ''  //编辑新模块时更新的catalogId
    };
  },
  props: {
      from: {
          type: String,
      },
      coilingId: {
          type: Number,
      }
  },
  watch: {
    "form.type"(newValue) {
      console.log("form.type", newValue,this.editType);
      if(this.editType=='add'){
        return;
      }
      if(typeof newValue === 'string'){
        if(newValue.indexOf('/')!=-1){
          newValue.split('/');
        }else{
          newValue = [newValue,'']
        }
      }
      //如果是新增模块，需要在此处将type传给答题流程  数组类型取第一个
      if (!this.hasType) {
          let typeVal = newValue[0];
          EventBus.$emit("getType", typeVal);
          EventBus.$emit("getBookAndRegion", {
            bookId:this.$route.query.bookId,
            regionId:this.$route.query.regionId,
            type:typeVal,
            catalogId:this.$route.query.catalogId
          });
      }
      if(newValue[1]) {
        EventBus.$emit("changeSpecialType", newValue[1]);
      }
      // 触发获取套卷列表
      isAddressType.isAddressType = this.boolModuleLeve();  //之前逻辑为判断是否为北京的专项训练，现在按模块层级判断
      // isAddressType.isAddressType =
      //   (this.form.address == "北京" && this.form.type == "题型专项训练") ||
      //   !this.form.type;
      if (isAddressType.isAddressType) return;
      this.$parent.getCoiling();
    },
  },

  methods: {
    ...mapMutations(["totalEnableChange", "isTreeShowChange"]),
    handleModuleChange(e) {
        //this.$set(this.form, "module", this.form.module);
      this.$parent.getCoiling();
        
      this.isDisabled = true;
      this.getModuleStatusInit();
      
      // console.log('级联选择触发变化',e);
      this.isTreeShowChange(e.includes("题型专项训练"));
    },
    boolModuleLeve(){
      if(this.moduleArr.length){
        if(typeof this.form.type == 'string'){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },
    // 级联选择触发变化
    handleChange(e) {
      this.isDisabled = true;
      this.getModuleStatusInit();

      let moduleText = '';
      e.some((item,index)=>{
        if(index==0){
          moduleText+=item
        }else{
          moduleText+='/'+item
        }
      })
      this.$store.commit('updateModuleType', moduleText)
      
      // console.log('级联选择触发变化',e);
      this.isTreeShowChange(e.includes("题型专项训练"));
    },
    updateModule(){
      this.$emit("updateModule",this.form.type)
    },
    updateBookModule(){
      if(!this.form.type){
        return;
      }else{
        const lastChar = this.form.type.slice(-1);
        if(lastChar=='/'){
          this.$message({
            message: "请输入二级模块名称",
            type: "warning",
          });
          return;
        }
      }
      sessionStorage.setItem("editModuleName",this.form.type);
      EventBus.$emit("updateModuleStatus");

      checkModuleName({'bookId':this.$route.query.bookId||'','catalogType':this.form.type}).then((res) => {
        console.log(TAG + "res1", res);
        if (res && res["code"] == 0) {
          console.log(TAG + "res", res);
          // this.$set(this.form, "delivery", e);

          // 总的启用变化，详情启用全部变化
          // this.totalEnableChange(e);
          if(res.data){
            this.$message({
              message: "模块名已存在",
              type: "warning",
            });
            this.form.type = ""
          }else{
            this.$store.commit('updateModuleType', this.form.type)
          }
        } else {
          this.$message.error(res.info);
        }
      })
      .catch((err) => {
        console.log(TAG + "err", err);
        // this.$message.error("请先添加试卷");
      });
      // this.$emit("updateBookModule",this.form.type)
    },
    // 保存试题内容
    onSubmit() {
      switch(this.$store.state.pageNum){
        case "1":
          // 判断是否是"北京"  "题型专项训练"拦截
          if (isAddressType.isAddressType) {
            this.$message.error("请先选择类型");
            return;
          }
          break;
        case "2":
          if(this.coilingId == null || this.coilingId == ''){ //当paperId为空时,说明该节点无试卷,此时无法保存数据
            this.$message.error("请先添加试卷");
            return;
          }
          break;
      }

      EventBus.$emit("saveCoiling");
    },

    // 启用变化
    deliveryChange(e) {
      this.$set(this.form, "delivery", !e);

      // 判断是否是"北京"  "题型专项训练"拦截
      if (isAddressType.isAddressType) {
        this.$message.error("请先选择类型");
        return;
      }

      console.log(TAG + "deliveryChange", e);
      let content_1 = !e
        ? "禁用后，将关闭该模块下单元等启用权限"
        : "启用后，还需打开该模块下单元等启用权限";
      let content_2 = !e ? "是否禁用当前模块？" : "是否启用当前模块？";
      let confirm_text = !e ? "禁用" : "启用";

      this.$confirm(content_1, content_2, {
        distinguishCancelAndClose: true,
        confirmButtonText: confirm_text,
        cancelButtonText: "取消",
        customClass: "customClass_2",
        confirmButtonClass: "btnConfirm",
        cancelButtonClass: "btnCancel",
      })
        .then(() => {
          this.deliveryChangeCopy(e);
        })
        .catch(() => {});
    },

    // 启用变化
    deliveryChangeCopy(e) {
      const errorFn = () => {
        let errorVal = e ? "启用开启失败!" : "启用关闭失败!";
        this.$message.error(errorVal);

        setTimeout(() => {
          this.$set(this.form, "delivery", !e);
        }, 1000);
      };

      let bookId = this.$route.query.bookId;

      if (!bookId) {
        errorFn();
        return;
      }

      let type = "";
      let typeOld = this.form.type;
      if (typeof typeOld == "string") {
        type = typeOld;
      } else if (typeOld instanceof Array) {
        type = typeOld[0];
      }

      let data = {
        bookId,
        type,
        status: e ? 0 : 1,
      };

      console.log(TAG + "deliveryChange data", data);

      if(this.from =='special'){
        data= {
          id: this.catalog_Id||this.$route.query.catalogId,
          status: e ? 0 : 1,
        }
      }

      // 接口-设置启用变化
      changeModuleStatus(data)
        .then((res) => {
          console.log(TAG + "res1", res);
          if (res && res["code"] == 0) {
            console.log(TAG + "res", res);
            this.$set(this.form, "delivery", e);

            // 总的启用变化，详情启用全部变化
            this.totalEnableChange(e);
            this.$message({
              message: e ? "启用成功!" : "禁用成功!",
              type: "success",
            });
          } else {
            errorFn();
          }
        })
        .catch((err) => {
          console.log(TAG + "err", err);
          errorFn();
        });
    },
    getcatalogIdChange(data){
      this.catalog_Id = data;
    },
    // 初始获取启用
    getModuleStatusInit() {
      let bookId = this.$route.query.bookId;

      let catalogType = "";
      let typeOld = this.form.type;
      if (typeof typeOld == "string") {
        catalogType = typeOld;
      } else if (typeOld instanceof Array) {
        catalogType = typeOld[0];
      }
      let data = {
        bookId,
        catalogType,
      };
      if(this.from == 'special'){ //四期要加个参数
        data.catalogId = this.catalog_Id||this.$route.query.catalogId;
      }

      getModuleStatus(data).then((res) => {
        console.log(TAG + "getModuleStatus res1", res);
        if (res && res["code"] == 0) {
          console.log(TAG + "res", res);

          this.form.delivery = res["data"]["status"] == "0" ? true : false;
        } else {
          console.log(TAG + "res1", res);
        }
      });
    },

    // 预览
    preview() {
      EventBus.$emit("showPreview");
    },

    // saveLock(id){
    //   if(id){
    //     if(id==this.$store.state.coilingId){
    //       this.saveDisabled=false;
    //     }
    //   }else{
    //     this.saveDisabled=true;
    //   }
    // },
    disableModuleInput(){ //禁用input框
      this.isAddModuleDisabled=true;
      // let bookId = this.$route.query.bookId;
      // let moduleData = sessionStorage.getItem('moduleData');
      // let l1Text = '';
      // let l2Text = '';
      // if(form.type.indexOf('/')!=-1){
      //   let arr = form.type.split('/');
      //   l1Text = arr[0];
      //   l2Text = arr[1];
      //   moduleData.some((item,index)=>{
      //     if(bookId == item.bookId){
      //       item.catalogList.some((val,i)=>{

      //       })
      //     }
      //   })
      // }else{
      //   l1Text = form.type;
      //   moduleData.some((item,index)=>{
      //     if(bookId == item.bookId){

      //     }
      //   })
      // }
    },
    getModuleData(){
      getModuleList({'bookId':this.$route.query.bookId,'catalogType':this.form.type}).then((res) => {
        console.log(TAG + "getModuleStatus res1", res);
        if (res && res["code"] == 0) {
          console.log(TAG + "res", res);
          this.options = [{
            value: this.$route.query.type,
            label: this.$route.query.type,
            // children: [{
            //   value: "1",
            //   label: "1",
            // }]
          }];
          if(res.data.length){
            this.$store.commit('updateModuleType', this.$route.query.type+'/')
            this.options[0].children = [];
            res.data.some((item)=>{
              this.options[0].children.push({
                value: item,
                label: item,
              })
            })
          }else{
            this.$store.commit('updateModuleType', this.$route.query.type)
              this.isDisabled = Boolean(this.form.type);
              // this.$set(this.options[1], "disabled", true);
          }
          this.moduleArr = res.data;
          isAddressType.isAddressType = this.boolModuleLeve();
          // EventBus.$emit("getCoiling");
          // this.form.type = "";
          // setTimeout(()=>{
          //   _this.form.type = "1"//this.$route.query.type;
          // },2000)
          
        } else {
          console.log(TAG + "res1", res);
        }
      });
    }
  },

  mounted() {
    isAddressType.isAddressType = false;
    console.log('==========this.$route.query=======',this.$route.query)
    this.form.address = this.$route.query.region;
    this.form.source = this.$route.query.questionSource;
    this.form.year = this.$route.query.year;
    this.form.type = this.$route.query.type;
    if(!this.$route.query.type){
      sessionStorage.setItem("editModuleName",'');
    }

    this.$store.commit('updateModuleType', '')

    this.editType = this.$route.query.type?'edit':'add';
    this.$emit("getForm",this.form)
    this.isModuleDisabled = this.$route.query.type?true:false
    ////将type传给答题流程
    //将id，和regionId
    this.$nextTick(() =>{
      EventBus.$emit("getBookAndRegion", {
        bookId:this.$route.query.bookId,
        regionId:this.$route.query.regionId,
        type:this.form.type,
        catalogId:this.$route.query.catalogId
      });
    })
    //将type传给答题流程
    if (this.form.type) {
      this.hasType = true;
      //等待流程页面创建完成再发送
      this.$nextTick(() => {
        EventBus.$emit("getType", this.form.type);
      });
    }

    
    // if (this.form.address == "北京") {
    //   this.isDisabled = this.form.type == "听说-模拟训练";
    //   this.options[1].children = [
    //     {
    //       value: "听后回答",
    //       label: "听后回答",
    //     },
    //     {
    //       value: "听后转述",
    //       label: "听后转述",
    //     },
    //   ];
    //   this.$set(this.options[0], "disabled", this.form.type == "题型-专项训练");
    // } else {
    //   this.isDisabled = Boolean(this.form.type);
    //   this.$set(this.options[1], "disabled", true);
    // }
    this.getModuleData();

    this.getModuleStatusInit();

    // 新增模块-详情启用-变化
    EventBus.$on("detailEnableChange", this.getModuleStatusInit);
    // EventBus.$on("addSaveBtnLock",this.saveLock);
    EventBus.$on("disableModuleInput",this.disableModuleInput);
    EventBus.$on("getcatalogIdChange",this.getcatalogIdChange);
  },

  beforeDestroy() {
    this.totalEnableChange(undefined);
    // EventBus.$off("addSaveBtnLock",this.saveLock);
    EventBus.$off("detailEnableChange", this.getModuleStatusInit);
    EventBus.$off("disableModuleInput",this.disableModuleInput);
    EventBus.$off("getcatalogIdChange",this.getcatalogIdChange);
  },
};
</script>

<style lang="scss" scoped>
.addressClass {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.addressFilter {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

:deep .btnAddress span {
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 14rem;
    height: 14rem;
    margin-right: 6rem;
  }
}
.btnAddress {
  font-size: 14rem;
  color: #fff;
  padding: 8rem 16rem;
  background-image: var(--background-image);
}
.addressClass {
  .btnAddress:hover,
  .btnAddress:active {
    background-image: var(--background-image);
    background: var(--background-image);
  }
  .preview,
  .preview:hover {
    background-image: linear-gradient(to right, #0078e7, #0295ff);
  }
}
</style>

<style>
.btnAddress {
  font-size: 14rem;
}
.btnAddress span {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.btnAddress span img {
  width: 14rem;
  height: 14rem;
  margin-right: 6rem;
}
</style>
<style lang='scss'>
  .customClass_2{
        width:460rem;
        border-radius: 8rem;
        box-sizing: border-box;
        .el-message-box__header .el-message-box__title span{
            margin-left: 20rem;
            &::before{
                content:url(@/views/question/static/warning.png); 
             
                position: relative;
                top:5rem;
                left: -15rem;
            }
        }
        .el-message-box__headerbtn .el-message-box__close{
            // color: #ff0000;
            transform: scale(1.4,1.4);
            margin-top: 10rem;
        }
        .el-message-box__title{
            font-size: 18rem;
            color: #000000;
            font-weight:bold;
            height: 30rem;
            span{
                position: absolute;
                top: 12rem;
            }
        }
        .el-message-box__content{
            font-size: 14rem;
            height: 24rem;
            p{
                margin-left: 48rem;
                position: absolute;
                top: -5rem;
            }
        }
    }
</style>